// ** Initial State
const initialState = {
  dropdown: [],
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedWorkpassType: null
}

const workpassTypes = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_WORKPASS_TYPES_DROPDOWN':
      return { ...state, dropdown: action.data }
    case 'GET_ALL_WORKPASS_TYPES':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_WORKPASS_TYPES':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_WORKPASS_TYPE':
      return { ...state, selectedWorkpassType: action.selectedWorkpassType }
    case 'ADD_WORKPASS_TYPE':
      return { ...state }
    case 'DELETE_WORKPASS_TYPE':
      return { ...state }
    default:
      return { ...state }
  }
}
export default workpassTypes
